import { render, staticRenderFns } from "./DeliveryAddress.vue?vue&type=template&id=f85c5568&scoped=true&"
import script from "./DeliveryAddress.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddress.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAddress.vue?vue&type=style&index=0&id=f85c5568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85c5568",
  null
  
)

export default component.exports